import { render } from "./TrendsListWindow.vue?vue&type=template&id=76feee1c&scoped=true"
import script from "./TrendsListWindow.vue?vue&type=script&lang=js"
export * from "./TrendsListWindow.vue?vue&type=script&lang=js"

import "./TrendsListWindow.vue?vue&type=style&index=0&id=76feee1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76feee1c"]])

export default __exports__